import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { appConfig } from 'projects/petszel-owner/src/owner.config';
import type { TaskProgram } from './task.model';

@Injectable({ providedIn: 'root' })
export class OwnerTasksService {
  constructor(private http: HttpClient) {}

  private authHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : new HttpHeaders();
  }

  private params(petszelOwnerId: string, petszelAnimalId: string, animalTaskId?: string): HttpParams {
    const obj: Record<string, string> = { petszelOwnerId, petszelAnimalId };
    if (animalTaskId) obj['animalTaskId'] = animalTaskId;
    return new HttpParams({ fromObject: obj });
  }

  /**
   * GET /Owner/ActiveTaskSet?petszelOwnerId=...&petszelAnimalId=...
   */
  getActiveTaskSet(petszelOwnerId: string, petszelAnimalId: string): Observable<TaskProgram> {
    const url = `${appConfig.apiUrl}Owner/ActiveTaskSet`;
    return this.http.get<TaskProgram>(url, {
      headers: this.authHeaders(),
      params: this.params(petszelOwnerId, petszelAnimalId),
    });
  }

  /**
   * PUT /Owner/ActiveTaskSet/Complete?petszelOwnerId=...&petszelAnimalId=...&animalTaskId=...
   */
  completeActiveTask(
    petszelOwnerId: string,
    petszelAnimalId: string,
    animalTaskId: string
  ): Observable<TaskProgram> {
    const url = `${appConfig.apiUrl}Owner/ActiveTaskSet/Complete`;
    return this.http.put<TaskProgram>(url, null, {
      headers: this.authHeaders(),
      params: this.params(petszelOwnerId, petszelAnimalId, animalTaskId),
    });
  }

  /**
   * PUT /Owner/ActiveTaskSet/Dismiss?petszelOwnerId=...&petszelAnimalId=...&animalTaskId=...
   */
  dismissActiveTask(
    petszelOwnerId: string,
    petszelAnimalId: string,
    animalTaskId: string
  ): Observable<TaskProgram> {
    const url = `${appConfig.apiUrl}Owner/ActiveTaskSet/Dismiss`;
    return this.http.put<TaskProgram>(url, null, {
      headers: this.authHeaders(),
      params: this.params(petszelOwnerId, petszelAnimalId, animalTaskId),
    });
  }

    /**
   * PUT /Owner/ActiveTaskSet/CompleteArticle/{articleRichTextId}?petszelOwnerId=...&petszelAnimalId=...
   */
  completeArticleTask(
    petszelOwnerId: string,
    petszelAnimalId: string,
    articleRichTextId: string
  ): Observable<TaskProgram> {
    const url = `${appConfig.apiUrl}Owner/ActiveTaskSet/CompleteArticle/${encodeURIComponent(
      articleRichTextId
    )}`;

    return this.http.put<TaskProgram>(url, null, {
      headers: this.authHeaders(),
      params: this.params(petszelOwnerId, petszelAnimalId),
    });
  }

  /**
   * PUT /Owner/ActiveTaskSet/CompleteVideo/{articleVideoId}?petszelOwnerId=...&petszelAnimalId=...
   */
  completeVideoTask(
    petszelOwnerId: string,
    petszelAnimalId: string,
    articleVideoId: string
  ): Observable<TaskProgram> {
    const url = `${appConfig.apiUrl}Owner/ActiveTaskSet/CompleteVideo/${encodeURIComponent(
      articleVideoId
    )}`;

    return this.http.put<TaskProgram>(url, null, {
      headers: this.authHeaders(),
      params: this.params(petszelOwnerId, petszelAnimalId),
    });
  }

    /**
   * PUT /Owner/ActiveTaskSet/Pending?petszelOwnerId=...&petszelAnimalId=...&animalTaskId=...
   */
  pendingActiveTask(
    petszelOwnerId: string,
    petszelAnimalId: string,
    animalTaskId: string
  ): Observable<TaskProgram> {
    const url = `${appConfig.apiUrl}Owner/ActiveTaskSet/Pending`;

    return this.http.put<TaskProgram>(url, null, {
      headers: this.authHeaders(),
      params: this.params(petszelOwnerId, petszelAnimalId, animalTaskId),
    });
  }
}
